import m from 'mithril'
import s from './styles.module.scss'
import { initMithrilComponent } from '@client-shared/utils/mithril'

interface ILoaderDotPulseAttrs {
	inline: boolean
	black: boolean
}

const LoaderDotPulse = initMithrilComponent<ILoaderDotPulseAttrs>()
LoaderDotPulse.view = (vnode) => {
	if (!vnode?.attrs) return
	const inline = vnode.attrs.inline
	const black = vnode.attrs.black
	return m(
		'div',
		{ class: [s.dot_pulse_wrapper, inline ? s.inline : null, black ? s.black : null].join(' ') },
		m('div', { class: s.dot_pulse }),
	)
}

export default LoaderDotPulse
